import { createStore } from "@ngneat/elf";
import { withEntities } from "@ngneat/elf-entities";
import { withRequestsStatus } from "@ngneat/elf-requests";
import { ToolboxColumn } from "@store/toolbox/toolbox.model";

export const toolboxStore = createStore({ name: "toolbox" }, withEntities<ToolboxColumn>(), withRequestsStatus());
